// 更换品牌名称、口号或展示内容时，在这里集中调整。
export const brand = { name: 'JunoYi', tagline: 'Build. Share. Evolve.' };

export const navigation = [
  { key: 'home', href: '/' },
  // The standalone products module stays hidden until its real catalog is ready.
  { key: 'openSource', href: '/open-source' },
  { key: 'services', href: '/services' },
  { key: 'docs', href: '/docs' },
  { key: 'community', href: '/community' },
  { key: 'company', href: '/company' },
];

// 设计初稿的示意内容，发布前需按实际产品与服务确认。
export const products = [
  {
    name: 'Status Deck',
    kind: 'status',
  },
  {
    name: 'Writing Assistant',
    kind: 'writing',
  },
  {
    name: 'Task Flow',
    kind: 'task',
  },
];

export const services = [
  { key: 'digital' },
  { key: 'systems' },
  { key: 'iot' },
  { key: 'architecture' },
];
